module.exports = __webpack_public_path__ + "img/pos-icon-active.430caa25.svg";